import React from 'react';

export const ServicePayDescription = () => (
  <>
    <p>
      Service pay is separate from VA disability compensation. Service pay
      includes these types of pay you may get from the military:
    </p>
    <ul>
      <li>
        <strong>Retired pay</strong> you receive after leaving military service
      </li>
      <li>
        <strong>Training pay</strong> for inactive duty (like drills or annual
        training) or active duty training
      </li>
    </ul>
  </>
);

export const servicePayYesNoUIHint =
  'We’ll ask you more questions about your service pay later in this form.';
